import { render } from "./AvatarDropdown.vue?vue&type=template&id=2247bdcd&scoped=true"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js"

import "./AvatarDropdown.vue?vue&type=style&index=0&id=2247bdcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2247bdcd"]])

export default __exports__